export default {
  path: "/main/product/category",
  name: "Category",
  component: () => import("@/views/main/Product/category.vue"),
  children: []
};
